<template>
  <div class="OrganizationsDropdown">
    <div v-if="organizations.length > 1">
      <VDropdown ref="dropdownComponent" :distance="6" placement="left">
        <h1>
          <span v-if="currentOrganization">{{ currentOrganization.name }}</span>
          <i class="arrow fa fa-angle-down" />
        </h1>

        <template #popper>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <div v-for="organization in organizations" :key="organization.id">
              <router-link
                :to="{ path: `/organizations/${organization.id}/dashboard` }"
                :class="
                  currentOrganization === organization
                    ? 'dropdown-item active'
                    : 'dropdown-item'
                "
              >
                {{ organization.name }}
              </router-link>
            </div>
          </div>
        </template>
      </VDropdown>
    </div>

    <div v-else>
      <h1 v-if="currentOrganization">
        {{ currentOrganization.name }}
      </h1>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Dropdown as VDropdown } from 'floating-vue'
import './style.scss'

export default {
  name: 'OrganizationsDropdown',
  components: { VDropdown },
  computed: {
    ...mapGetters({
      loading: 'loadingOrganizations',
      organizations: 'organizations',
      currentOrganization: 'organization',
    }),
  },
  watch: {
    $route(to, from) {
      if (this.$refs.dropdownComponent) {
        this.$refs.dropdownComponent.hide()
      }
    },
  },
  mounted() {
    this.$store.dispatch('fetchOrganizations')
  },
}
</script>
